//高级函数--7个
export const AdvancedFunc = [
  {
    "key": "if",
    "name": "if()\n{\n\n}",
    "params": [],
    "description": "if條件成立，執行括號中內容",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "if else",
    "name": "if()\n{\n\n}\nelse\n{\n\n}",
    "params": [],
    "description": "if條件成立，執行括號中內容；否則執行else中內容",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "for",
    "name": "for(;;)\n{\n\n}",
    "params": [],
    "description": "for循環：示例：for(var i=0;i<5;i++){}",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "return",
    "name": "return ;",
    "params": [],
    "description": "返回值",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "var",
    "name": "var ",
    "params": [],
    "description": "變量定義",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "true",
    "name": "true ",
    "params": [],
    "description": "正確",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "false",
    "name": "false ",
    "params": [],
    "description": "錯誤",
    "type": "Advanced",
    "keyFront": "",
    "className": ""
  },
  {
    "key": "Invoke",
    "name": "内置擴展調用",
    "params": [],
    "description": "内置擴展調用函數調用方法",
    "type": "",
    "keyFront": "DefaultExtendFunctionProxy",
    "className": ""
  }
]